// @ts-check
import { route } from './author.js';
export const SECURITY_LEVELS = [
  route(7, 1, 'Scan Line', 'Scanning strips charge before firing. Jump their beams or wait behind cover.', 150)
    .node(9).device('scanner', 17, 0, 10, 0.7, 5).platform(23, 0, 1, 1)
    .device('scanner', 33, 0, 9, 0.7, 5, { offset: 2 }).platform(39, 0, 1, 1).checkpoint(48, 'Blind spot')
    .node(54).device('scanner', 62, 0, 12, 0.7, 5).platform(70, 0, 1, 1).bot(80, 0, true)
    .gap(86, 3).checkpoint(96, 'Scan boundary').device('scanner', 104, 0, 10, 0.7, 4.5)
    .platform(110, 0, 1, 1).node(118, 3, 'overclock').device('scanner', 126, 0, 10, 0.7, 4.5, { offset: 2 }).platform(133, 0, 1, 1).build(),
  route(7, 2, 'Access Path', 'Signal nodes control shield paths. Use the cover between scan volumes.', 160)
    .node(9, 3, 'upgrade', 'access').device('phase', 18, 0, 1, 3, 4, { group: 'access' })
    .device('scanner', 27, 0, 10, 0.7, 5).platform(34, 0, 1, 1).checkpoint(46, 'Access anchor')
    .node(53, 3, 'bit', 'shield').device('phase', 61, 0, 1, 3, 4, { group: 'shield' })
    .device('scanner', 69, 0, 11, 0.7, 5).platform(76, 0, 1, 1).node(84)
    .checkpoint(95, 'Shield boundary').device('carrier', 103, 1, 3, 0.5, 5, { travelY: 3 })
    .platform(110, 4, 4, 0.5).node(114, 6, 'overclock').device('scanner', 122, 0, 11, 0.7, 4.5)
    .platform(130, 0, 1, 1).bot(141, 0, true).build(),
  route(7, 3, 'False Positive', 'Cross the scan at its quiet moment. Open a decoy route from each relay.', 166)
    .node(9, 3, 'upgrade', 'decoy').device('phase', 17, 2, 4, 0.5, 4, { group: 'decoy', alternate: true })
    .device('scanner', 25, 0, 12, 0.7, 5).platform(33, 0, 1, 1).node(39, 3, 'bit', 'decoy')
    .checkpoint(47, 'Decoy relay').device('scanner', 55, 0, 12, 0.7, 4.5).platform(63, 0, 1, 1)
    .device('gate', 72, 0, 1, 3, 4.5).node(79).device('scanner', 85, 0, 8, 0.7, 4.5, { offset: 2 })
    .platform(90, 0, 1, 1).checkpoint(99, 'Safe signature').node(106, 3, 'bit', 'return')
    .gap(114, 6).device('phase', 114, 0, 6, 0.5, 4, { group: 'return' })
    .device('scanner', 128, 0, 11, 0.7, 4.5).platform(136, 0, 1, 1).node(144, 3, 'overclock').bot(154).build(),
  route(7, 4, 'Watchdog Protocol', 'Bait the lock-on, jump the charge, then land on the exposed security core.', 110)
    .node(9).device('scanner', 17, 0, 10, 0.7, 5).platform(24, 0, 1, 1)
    .device('gate', 34, 0, 1, 3, 5).device('scanner', 43, 0, 10, 0.7, 5).platform(50, 0, 1, 1)
    .node(58).bot(65, 0, true).boss('watchdog', 'Watchdog', 5).build(),
];
